//@flow
import React from 'react';

import bannerSize1 from '../../../../../../../assets/img/main-banner/banner-size-1.webp';
import bannerSize2 from '../../../../../../../assets/img/main-banner/banner-size-2.webp';
import {Button, makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
import {useFormContext} from 'react-hook-form';
import {BANNER_SHAPE_OPTIONS, MAIN_BANNER_FIELDS} from '../constants';
import {BANNER_MEDIA_SIZES} from '../../../../../constants';

const useStyles = makeStyles(theme => ({
  items: {
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  buttonWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '.5rem',
    flexGrow: 1,
  },
  itemButton: {
    flexGrow: 1,
    padding: 0,
    width: '100%',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    position: 'relative',
  },
  item: {
    width: '100%',
    height: '100%',
    background: '#F2F2F2',
    borderRadius: '.5rem',
    padding: '1.5rem 1rem 1rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '.75rem',
    cursor: 'pointer',
    position: 'relative',
  },
  itemLabel: {
    display: 'block',
    textAlign: 'center',
    color: colors.grey600,
    fontSize: '.75rem',
    fontWeight: 600,
  },
  layoutThumbnail: {
    width: '100%',
    maxWidth: '250px',
  },
  checkbox: {
    position: 'absolute',
    top: '.5rem',
    left: '.5rem',
    width: '1.25rem',
    height: '1.25rem',
    background: '#fff',
    borderRadius: '50%',
    border: '1px solid #E0E0E0',
    transition: 'border .2s ease-in-out',

    '&[data-checked=true]': {
      border: `.35rem solid ${colors.primary}`,
    },
  },
  labelSize: {
    width: '100%',
    display: 'flex',
    gap: '.25rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

const SIZES = [
  {
    name: BANNER_SHAPE_OPTIONS.FLAT,
    image: bannerSize1,
    label: 'Plano',
    sizeLabel: {
      desktop: `${BANNER_MEDIA_SIZES.FLAT.desktop.width} x ${BANNER_MEDIA_SIZES.FLAT.desktop.height}`,
      mobile: `${BANNER_MEDIA_SIZES.FLAT.mobile.width} x ${BANNER_MEDIA_SIZES.FLAT.mobile.height}`,
    },
  },
  {
    name: BANNER_SHAPE_OPTIONS.TALL,
    image: bannerSize2,
    label: 'Alto',
    sizeLabel: {
      desktop: `${BANNER_MEDIA_SIZES.TALL.desktop.width} x ${BANNER_MEDIA_SIZES.TALL.desktop.height}`,
      mobile: `${BANNER_MEDIA_SIZES.TALL.mobile.width} x ${BANNER_MEDIA_SIZES.TALL.mobile.height}`,
    },
  },
];

export default function BannerSize() {
  const classes = useStyles();

  const {setValue, watch} = useFormContext();

  const sizeSelected = watch(MAIN_BANNER_FIELDS.BANNER_SIZE);

  return (
    <div className={classes.items}>
      {SIZES.map((size, index) => (
        <div key={size.name} className={classes.buttonWrap}>
          <Button
            className={classes.itemButton}
            onClick={() => {
              setValue(MAIN_BANNER_FIELDS.BANNER_SIZE, size.name);
            }}
          >
            <div className={classes.item} data-hide-thumbnail>
              <span className={classes.itemLabel}>{size.label}</span>
              <div
                className={classes.checkbox}
                data-hide-thumbnail
                data-checked={sizeSelected === size.name}
              ></div>
              <img
                className={classes.layoutThumbnail}
                src={size.image}
                alt={`dimension ${index}`}
              />
            </div>
          </Button>
          <footer className={classes.labelSize}>
            <Typography
              variant="body2"
              color={sizeSelected === size.name ? 'initial' : 'textSecondary'}
            >
              Desktop: {size.sizeLabel.desktop}
            </Typography>
            <Typography
              variant="body2"
              color={sizeSelected === size.name ? 'initial' : 'textSecondary'}
            >
              Mobile: {size.sizeLabel.mobile}
            </Typography>
          </footer>
        </div>
      ))}
    </div>
  );
}
